export default __webpack_public_path__ + "static/media/service.e11a8041.svg";